
<div class="ui-g">
    <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
        <p-panel header="{{ 'my_details' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
            <app-user-details-form [isAdmin]="false" [userId]="0"></app-user-details-form>
        </p-panel>
    </div>    
</div>